import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b39df5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"20px"} }, "用户名：admin", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "初始密码：admin", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("修改密码")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_lock_outlined = _resolveComponent("lock-outlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_page_container = _resolveComponent("page-container")!

  return (_openBlock(), _createBlock(_component_page_container, {
    title: "设置密码",
    "sub-title": ""
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_alert, {
          message: "提示：安全起见，请一定要修改初始密码",
          type: "warning"
        }),
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_a_form, {
          ref: "formEle",
          model: _ctx.formState,
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { name: "oldPassword" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  size: "large",
                  placeholder: "请输入原密码",
                  autocomplete: "",
                  value: _ctx.formState.oldPassword,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.oldPassword) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_lock_outlined, {
                      style: _normalizeStyle({ color: 'rgba(0,0,0,.25)' })
                    }, null, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { name: "newPassword" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  size: "large",
                  placeholder: "请输入新密码",
                  autocomplete: "",
                  value: _ctx.formState.newPassword,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.newPassword) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_lock_outlined, {
                      style: _normalizeStyle({ color: 'rgba(0,0,0,.25)' })
                    }, null, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { name: "newPasswordToo" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  size: "large",
                  placeholder: "请再次输入新密码",
                  autocomplete: "",
                  value: _ctx.formState.newPasswordToo,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.newPasswordToo) = $event))
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_lock_outlined, {
                      style: _normalizeStyle({ color: 'rgba(0,0,0,.25)' })
                    }, null, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { style: {"margin-top":"24px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  size: "large",
                  type: "primary",
                  class: "submit-button",
                  loading: _ctx.btnLoading,
                  disabled: _ctx.btnLoading,
                  onClick: _ctx.onSubmit
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _: 1
  }))
}